export interface IDialogInitialState {
    isOpening: boolean;
}

export const dialogState: IDialogInitialState = {
    isOpening: false,
};
